/**
 * Canais de demonstração — visíveis quando o dispositivo ainda não foi ativado.
 */
import { XtreamContent, UICategory } from '../api/xtreamAPI';

export const DEMO_CATEGORY: UICategory = {
  id: 'demo',
  name: 'Demo',
  type: 'livestreams',
  count: 4,
};

export const DEMO_CHANNELS: XtreamContent[] = [
  {
    stream_id: 'demo-amazon-sat',
    name: 'Amazon SAT Brasil HD',
    icon: '',
    category_id: 'demo',
    stream_type: 'live',
    direct_source: 'https://amazonsat.brasilstream.com.br/hls/amazonsat/index.m3u8',
  },
  {
    stream_id: 'demo-cbs-news',
    name: 'CBS News',
    icon: '',
    category_id: 'demo',
    stream_type: 'live',
    direct_source: 'https://dai.google.com/linear/hls/pa/event/Sid4xiTQTkCT1SLu6rjUSQ/stream/5c7c7026-0a18-4197-8920-c8ebee5613af:SCL2/master.m3u8',
  },
  {
    stream_id: 'demo-apple-bipbop',
    name: 'Apple Test BipBop',
    icon: '',
    category_id: 'demo',
    stream_type: 'live',
    direct_source: 'http://devimages.apple.com/iphone/samples/bipbop/bipbopall.m3u8',
  },
  {
    stream_id: 'demo-apple-jobs',
    name: 'Apple Jobs Presentation',
    icon: '',
    category_id: 'demo',
    stream_type: 'live',
    direct_source: 'http://qthttp.apple.com.edgesuite.net/1010qwoeiuryfg/sl.m3u8',
  },
];
